import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useFarbwelt, useTestId } from "@/hooks";
import { FarbweltTeaser } from "./FarbweltTeaser";
import { useScrollEffect } from "@/hooks/useScrollEffect";
import { useRef } from "react";
import { useConfig, useFeaturesEnabled } from "@/contexts/cdpConfig";
export const FarbweltDesktopTeasers = () => {
    const { teasers } = useFarbwelt();
    const testId = useTestId("Farbwelt.Teasers");
    const isPreviewMode = useConfig().previewMode;
    const { openedContactForm } = useFeaturesEnabled();
    const mediumRectangleTop = Array.isArray(teasers) && // temporary fix while we wait for bff to return an array
        (teasers === null || teasers === void 0 ? void 0 : teasers.find((teaser) => teaser.type === "MediumRectangleTop"));
    const mediumRectangleBottom = Array.isArray(teasers) && // temporary fix while we wait for bff to return an array
        (teasers === null || teasers === void 0 ? void 0 : teasers.find((teaser) => teaser.type === "MediumRectangleBottom"));
    const teaserRef1 = useRef(null);
    const teaserRef2 = useRef(null);
    const containerRef = useRef(null);
    useScrollEffect({
        stickyElementRef: teaserRef1,
        scrollableElementRef: teaserRef2,
        containerRef,
        initialOffset: openedContactForm ? "500%" : "100%",
    });
    if (isPreviewMode) {
        return null;
    }
    return (_jsx(Box, { ref: containerRef, overflowY: "hidden", width: "100%", unsafe_className: "HideOnPrint", children: teasers && (_jsxs(_Fragment, { children: [_jsx(Box, { ref: teaserRef1, testId: `${testId}.MediumRectangleTop`, children: _jsx(FarbweltTeaser, { teaser: mediumRectangleTop, av_zone: "side" }) }), _jsx(Box, { ref: teaserRef2, testId: `${testId}.MediumRectangleBottom`, transform: `translateY(100%)`, children: _jsx(FarbweltTeaser, { teaser: mediumRectangleBottom, av_zone: "side" }) })] })) }));
};
